export * from './full-layout';
export * from './simple-layout';


// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/containers/index.ts